export default {"src":"/_next/static/media/placeholder.6cc85610.svg","height":435,"width":627,"blurWidth":0,"blurHeight":0};